import {
  REQUEST_TYPE_ACCOUNT,
  REQUEST_TYPE_ENTITLEMENT,
  REQUEST_TYPE_ROLE,
  REQUEST_TYPE_VALUEKEY,
} from './constant';

export const getArsKind = (nodeData) => {
  if (nodeData?.CERT_ENTITLEMENT_VALUEKEY === REQUEST_TYPE_VALUEKEY.ROLE)
    return REQUEST_TYPE_ROLE;
  if (nodeData?.CERT_ENTITLEMENT_VALUEKEY === REQUEST_TYPE_VALUEKEY.ACCOUNT)
    return REQUEST_TYPE_ACCOUNT;

  return REQUEST_TYPE_ENTITLEMENT;
};

export default getArsKind;
